/**
 * LoadingScreen Component
 *
 * Displays a minimal loading state with CatchUp branding while
 * the magic link token is being validated.
 *
 * Performance: < 5KB component size, CSS animations only
 */

interface LoadingScreenProps {
  testId?: string;
}

export function LoadingScreen({ testId = 'loading-screen' }: LoadingScreenProps) {
  return (
    <div
      className="min-h-screen bg-white flex flex-col items-center justify-center"
      data-testid={testId}
    >
      {/* CatchUp Brand Mark */}
      <div className="mb-8">
        <div className="text-6xl font-bold text-[#FF6B6B]">
          CatchUp
        </div>
      </div>

      {/* Coral Spinner */}
      <div className="relative w-16 h-16">
        <div className="absolute inset-0 border-4 border-gray-200 rounded-full" />
        <div className="absolute inset-0 border-4 border-[#FF6B6B] rounded-full border-t-transparent animate-spin" />
      </div>
    </div>
  );
}
